export default __webpack_public_path__ + "static/media/img-0056-usa-full-face.32a2bf0d.png";